import { Injectable } from '@angular/core';

import { Page, appPages } from './pages';
import { UserBasicService, UserBasicInfo } from '../shared/services/user-basic.service';

@Injectable({
  providedIn: 'root'
})
export class PagesAvailableService {
  private userInfo: UserBasicInfo;

  constructor(private readonly userInfoService: UserBasicService) { 
    this.userInfoService.basicInfo().subscribe((info: UserBasicInfo) => {
      this.userInfo = info;
    });
  }

  getAvailablePages(): Page[] {
    return (!this.userInfo) ? [] : appPages.filter(this.checkAvailablility.bind(this)).map(this.disablePage.bind(this));
  }
  
  checkCopyTrading(): boolean {
    let available = true;
    if ((this.userInfo?.Organization === 'Cyprus' || this.userInfo?.Organization === 'Jordan' || this.userInfo?.Organization == 'Palestine') && window.location.pathname == '/copy-trading'){
      available = false;
    }
    return available; 
  }

  private checkAvailablility(page: any): boolean {
    let available = true;

    if (this.userInfo.Status && page.url === '/complete-profile')
    available = false;

    if (!this.userInfo.Status && page.url === '/infoprofile') 
    available = false;

    if (this.userInfo.Organization === 'Cyprus' && page.url === '/update-leverage') 
    available = false;

    return available;
  }

  private disablePage(page: Page): Page {
    if (!this.userInfo.Verified && (
      page.url === '/reports' ||
      page.url === '/update-leverage' ||
      page.url === '/complete-profile' ||
      page.url === '/upload' 
    )) {
      page.disabled = true;
    } else {
      page.disabled = false;
    }
    return page;
  }
}
